const LoadingIndicator = () => {
  return (
    <div className="lds-ring" style={{ color: 'var(--accent-font-dark)' }}>
      <div />
    </div>
  );
};

export default LoadingIndicator;
